<css lang="scss" scoped>
.floating-window {
  border:1px solid gray;
  top:60%;
  position: fixed;
  width: 40vw;
  height: 90px;
  border: none; /* 移除默认的边框样式 */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0,0.2); /* 添加阴影效果 */
  border-radius: 5px; /* 添加圆角边框 */
  display: flex; /* 使用flexbox布局 */
  align-items: center; /* 垂直居中 */
  z-index:99

}
.icon-div {
  background-color: transparent; /* 背景透明 */
  // border-radius: 5px; /* 添加圆角边框 */
  // background-color: rgba(255, 255, 255, 0.2); /* 设置透明白色背景 */

  // box-shadow: 0 0 0 rgb(245, 155, 155); /* 初始状态：无阴影 */
  width: 90px;
  height: 90px;
  margin-left: -90px;
  margin-right: 5px;
  overflow: hidden;
}
.lottie-container {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bright {
  filter: brightness(400%) saturate(400%);
}
.music-button {
  margin-left: 1vw;

}
.img-avatar {
  margin-left:1vw;
}
#music {
  display: none;
}
@media screen and (max-width: 767px) {
  .slider {
    width: 25vw;
    margin-left:5vw;
  }
  .floating-window {
  border:1px solid gray;
  top:60%;
  position: fixed;
  width: 80vw;
  height: 110px;
  border: none; /* 移除默认的边框样式 */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0,0.2); /* 添加阴影效果 */
  border-radius: 5px; /* 添加圆角边框 */
  display: flex; /* 使用flexbox布局 */
  align-items: center; /* 垂直居中 */
  z-index:99

}
}
@media screen and (min-width: 768px) and (max-width: 1500px) {
  .slider {
    width: 15vw;
    margin-left:1vw;
  }
  .floating-window {
  border:1px solid gray;
  top:60%;
  position: fixed;
  width: 40vw;
  height: 90px;
  border: none; /* 移除默认的边框样式 */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0,0.2); /* 添加阴影效果 */
  border-radius: 5px; /* 添加圆角边框 */
  display: flex; /* 使用flexbox布局 */
  align-items: center; /* 垂直居中 */
  z-index:99
}
}
@media screen and (min-width: 1500px) {
  .slider {
    width: 15vw;
    margin-left:1vw;
  }
  .icon-div {
  background-color: transparent; /* 背景透明 */
  // border-radius: 5px; /* 添加圆角边框 */
  // background-color: rgba(255, 255, 255, 0.2); /* 设置透明白色背景 */

  // box-shadow: 0 0 0 rgb(245, 155, 155); /* 初始状态：无阴影 */
  width: 90px;
  height: 90px;
  margin-left: -90px;
  margin-right: 5px;
  overflow: hidden;
}
  .floating-window {
  border:1px solid gray;
  top:60%;
  position: fixed;
  width: 30vw;
  height: 90px;
  border: none; /* 移除默认的边框样式 */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0,0.2); /* 添加阴影效果 */
  border-radius: 5px; /* 添加圆角边框 */
  display: flex; /* 使用flexbox布局 */
  align-items: center; /* 垂直居中 */
  z-index:99

}
}
</css>
<template>
  <div class="floating-window" :style="{ right: rightStyle }" >
    
    <div class="icon-div" @click="showHover">
      <div ref="lottieContainer" class="lottie-container"></div>
    </div>
    <!-- <p style="color:white;font-size: 10px;margin-left:10px">这是音乐播放器</p> -->
    <audio id="music" controls ref="audio-player" preload="none"></audio>
    <div class="music-button">
      <span @click="musicPlay('pre')" style="margin-right:5px"><el-icon size="25" class="bright"><ArrowLeft /></el-icon></span>
      <span v-if="play" ><el-icon size="25" class="bright" @click="musicPlay('play')"><VideoPause /></el-icon></span>
      <span v-else ><el-icon size="25" class="bright" @click="musicPlay('play')"><VideoPlay /></el-icon></span>

      <span @click="musicPlay('next')" style="margin-left:5px"><el-icon size="25" class="bright"><ArrowRight /></el-icon></span>
    </div>
    <div class="img-avatar" v-if="music_list.length > 0"> <el-avatar shape="square" :size="50" :src="music_list[index].cover" /></div>
    <div class="slider" v-if="music_list.length > 0" >
      <span style="color:#F56F50">{{ music_list[index].name  }}</span>
      <el-slider
            class="progress"
            v-model="sliderVal"
            :format-tooltip="formatTooltip"
            :min="sliderMin"
            :max="sliderMax"
          />

          <span style="color:#55927B" class="current">{{ currentTime }}</span>
          <span style="color:#25619E" class="duration">/{{ duration }}</span>
    </div>
  </div>
</template>

<script>

import { ref , onMounted,onUnmounted, computed } from 'vue'
import { gsap } from 'gsap';
import { getMusic } from '@/api/backend'
import lottie from 'lottie-web'
import musicAnimation from '@/assets/music.json'
import { musicState, musicPlayerManager } from '@/store/musicStore'

export default {
  name:'MusicPlayer',
  emits: ['updateStatus'],
  setup(props,context) {
    const  rightStyle = ref('0')
    const box = ref(null);
    const musicStatus = ref(false)
    const lottieContainer = ref(null)
    const lottieInstance = ref(null)
    
    // 使用全局状态
    const music_list = computed(() => musicState.musicList)
    const index = computed(() => musicState.currentIndex)
    const play = computed(() => musicState.isPlaying)
    const sliderVal = computed({
      get: () => musicState.currentTime,
      set: (val) => musicPlayerManager.setCurrentTime(val)
    })
    const sliderMin = ref(0)
    const sliderMax = computed(() => musicState.duration)
    const sliderValVolumn = computed({
      get: () => musicState.volume,
      set: (val) => musicPlayerManager.setVolume(val)
    })
    const copySliderValVolumn = ref(0.5);
    const duration = computed(() => formatTime(musicState.duration))
    const currentTime = computed(() => formatTime(musicState.currentTime))

    const fetchData = async () => {
      try {
        const response = await getMusic();
        musicPlayerManager.setMusicList(response.data);
        console.log(music_list.value);
        init();
      } catch (error) {
        console.error(error);
      }
    };
  
    const handleResize = () => {
      if (window.innerWidth >= 768 && window.innerWidth <= 1500) {
        // PC 端样式
        rightStyle.value = '-40vw';
      } else if(window.innerWidth <= 768) {
        // 移动端样式
        rightStyle.value = '-80vw';
      }else {
        //大屏幕
        rightStyle.value = '-30vw';
      }
    };
    function init() {
      box.value = document.getElementById("music");
      console.log(box.value, "音频播放器DOM");
      
      // 初始化全局音乐播放器管理器
      musicPlayerManager.init(box.value);
      
      // 如果有音乐列表，加载当前音乐
      if (music_list.value.length > 0) {
        const currentMusic = musicPlayerManager.getCurrentMusic();
        if (currentMusic) {
          console.log('🎵 设置音乐源:', currentMusic.url_name);
          box.value.src = currentMusic.url_name;
          // 确保不会自动播放
          box.value.pause();
          box.value.currentTime = 0;
        }
      }
    }

    function musicPlay(flag) {
      console.log('🎵 MusicPlayer musicPlay 被调用:', flag);
      switch (flag) {
        case "pre":
          console.log('🎵 执行上一首');
          musicPlayerManager.previous();
          context.emit('updateStatus');
          break;
        case "play":
          console.log('🎵 执行播放/暂停');
          musicPlayerManager.togglePlay();
          context.emit('updateStatus');
          updateLottieAnimation();
          break;
        case "next":
          console.log('🎵 执行下一首');
          musicPlayerManager.next();
          context.emit('updateStatus');
          break;
      }
    }
    function spliderSelect(val) {
        console.log(val);
        musicPlayerManager.setCurrentTime(val);
      }

    function formatTooltip(val) {
        return formatTime(val); // 格式化当前时长
      }

    function formatTooltipVolumn(val) {
        return Math.round(val * 100) + "%"; // 格式化音量
      }

      // 时间格式化函数
    function formatTime(time) {
        const min = Math.floor(time / 60)
          .toString()
          .padStart(2, "0");
        const sec = Math.floor(time % 60)
          .toString()
          .padStart(2, "0");
        return `${min}:${sec}`;
      }
    function initLottie() {
      if (lottieContainer.value && !lottieInstance.value) {
        lottieInstance.value = lottie.loadAnimation({
          container: lottieContainer.value,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: musicAnimation
        });
        
        // 确保动画适应容器大小
        lottieInstance.value.addEventListener('DOMLoaded', () => {
          if (lottieInstance.value) {
            lottieInstance.value.resize();
          }
        });
      }
    }

    function updateLottieAnimation() {
      if (lottieInstance.value) {
        if (play.value) {
          lottieInstance.value.play();
        } else {
          lottieInstance.value.pause();
        }
      }
    }

    function showHover() {
      if (window.matchMedia("(max-width: 767px)").matches) {
          if (rightStyle.value === '-80vw') {
            gsap.to(rightStyle, { value: '0vw', duration: 1 });
          } else {
            gsap.to(rightStyle, { value: '-80vw', duration: 1 });
          }
      } else if (window.matchMedia("(min-width: 768px) and (max-width: 1500px)").matches) {
        if (rightStyle.value === '-40vw') {
          gsap.to(rightStyle, { value: '0vw', duration: 1 });
        } else {
          gsap.to(rightStyle, { value: '-40vw', duration: 1 });
        }
      } else {
        // 大于 1500px 的屏幕宽度逻辑
        if (rightStyle.value === '-30vw') {
          gsap.to(rightStyle, { value: '0vw', duration: 1 });
        } else {
          gsap.to(rightStyle, { value: '-30vw', duration: 1 });
        }
      }

        musicStatus.value = !musicStatus.value;
      }
    
  
    // const width = ref(window.innerWidth) // 缓存窗口宽度
    // window.addEventListener('resize', () => (width.value = window.innerWidth)) // 监听窗口宽度的变化

    // const isHover = ref(false) // 检测鼠标是否进入悬浮框
    // const rightStyle = computed(() => `${isHover.value ? "0vw" : "-18vw"}`) // 动态计算悬浮窗离右侧的距离
    onMounted(() => {
      // 只在第一次加载时获取音乐数据
      if (!musicState.isInitialized) {
        fetchData()
      } else {
        init()
      }
      
      // 确保音乐播放器不会自动播放
      setTimeout(() => {
        if (box.value) {
          console.log('🎵 确保音乐播放器不会自动播放');
          box.value.pause();
          box.value.currentTime = 0;
          
          // 添加事件监听器防止自动播放
          box.value.addEventListener('play', (e) => {
            if (!musicState.isPlaying) {
              console.log('🎵 检测到意外的自动播放，立即暂停');
              e.target.pause();
            }
          });
        }
      }, 200);
      
      window.addEventListener('resize', handleResize);
      handleResize(); // 页面加载时先执行一次以初始化样式
      // 等待 DOM 更新后初始化 Lottie
      setTimeout(() => {
        initLottie();
      }, 100);
    })
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    })
    return { showHover,
      rightStyle,musicStatus, box,handleResize,
      index,
      play,
      sliderVal,
      sliderMin,
      sliderMax,
      sliderValVolumn,
      copySliderValVolumn,
      duration,
      currentTime,
      musicPlay,
      spliderSelect,
      formatTooltip,
      formatTooltipVolumn,
      formatTime,music_list,
      lottieContainer,
      initLottie,
      updateLottieAnimation }
  },
}
</script>